import React, { FunctionComponent } from 'react'

import { useTheme } from 'styled-components/native'

import { getChatHeaderSubTitleLinkColor } from './chatHeaderSubTitleStyles'
import { Size as BodyTextSize } from '../../atoms/bodyText/BodyText'
import { Link, LinkProps } from '../../atoms/link/Link'
import { ThemeType } from '../../utils/themes/ThemeProvider'

export type ChatHeaderSubTitleLinkProps = Pick<LinkProps, 'text' | 'onPress' | 'testID' | 'accessibilityLabel'>

/**
 * Link rendered inside the chat header disclaimer subtitle (e.g. emergency number, "contact Lyra").
 * Links are medium weight and underlined so they stand out from the surrounding regular-weight disclaimer copy,
 * which shares their color.
 */
export const ChatHeaderSubTitleLink: FunctionComponent<ChatHeaderSubTitleLinkProps> = (props) => {
  const theme = useTheme() as ThemeType

  return <Link size={BodyTextSize.SMALL} medium underline color={getChatHeaderSubTitleLinkColor(theme)} {...props} />
}
